import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from "react-helmet";
import Header from '../body_root/header';
import Footers from '../body_root/footer';
import Navbar from '../body_root/Navbar';
import './support.css';
import { Toast } from '../components_root/ToastContext';
import { MdLocationCity } from "react-icons/md";
export const seo = {
    title: "aooz Support | Help Center & Customer Assistance",
    description: "Get support from aooz for all your needs. Find answers to FAQs, troubleshoot issues, and contact our team for help with online tools, SEO services, and premium features.",
    keywords: "aooz support, aooz help center, customer assistance, aooz faq, contact aooz, aooz customer service, aooz troubleshooting, online tools support",
    url: "https://aooz.in/support",
    image: "https://aooz.in/assets/logo.png"
};
export default function Support() {
    const [text, setText] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    return (
        <div>
          
            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots">
                <div className="container_size p-3">
                    <h2 className="text-xl font-bold mb-4">Support</h2>
                    <div className='post-container'>
 
                    </div>

                </div>
            
            </div>

           
            
        </div>
    );
}
